import Handsontable from 'handsontable';

export function applyFilters(ht: Handsontable) {
  const filterPlugin = ht.getPlugin('filters');
  filterPlugin.filter();
}
